import styled from "styled-components";
import {FreePlayDotIndicatorDefaultBox} from "./free-play-dot-indicator.default";

export const FreePlayDotIndicatorSIBox = styled(FreePlayDotIndicatorDefaultBox)`
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    background-color: ${props => props.theme.colors.buttonDark};
  }
`